import React from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './screens/home/Home';
import Header from './screens/header/Header.js';
import Footer from './screens/footer/Footer.js';
import About from './screens/about/About.js';
import Contact from './screens/Contact/Contact.js';
import Products from './common/Allproducts/Products.js';
import RefundPolicy from './common/refundpolicy/RefundPolicy.js';
import TermsAndConditions from './common/termsandcondition/TermAndCondition.js';
import CartPage from './common/cart/CartPage.js';
import PrivacyPolicy from './common/privacypolicy/PrivacyPolicy.js';
import SignUp from './common/login/SignUp.js';
import Login from './common/login/Login.js';
import Savouries from './common/savouries/Savouries.js';
import Sweets from './common/sweets/Sweets.js';
import Combo from './common/combo/Combo.js';
import Others from './common/others/Others.js';
import Gift from './common/gift/Gift.js';
import Header1 from './screens/header/Header1.js';
import ShopByCategory from './screens/shop/ShopbyCategory.js';
import Review from './screens/review/Review.js';
import Customize from './screens/customize/Customize.js';
import Account from '../src/common/account/Account.js';
import Whatsapp from './common/whatsapp/Whatsapp.js';
import CustomerSupport from "./common/support/CustomerSupport.js";
function App() {
  return (
    <>
    <Header></Header>
    <Header1></Header1>
    <Whatsapp></Whatsapp>
    
    <Routes>
      
    <Route path='/' element={<Home/>}></Route>
    <Route path='/about' element={<About/>}></Route>
    <Route path='/contact' element={<Contact />}></Route>
    <Route path='/products' element={<Products />}></Route>
    <Route path='/signup' element={<SignUp />}></Route>
    <Route path='/login' element={<Login />}></Route>
    <Route path='/cart' element={<CartPage />}></Route>
    <Route path='/account' element={<Account />}></Route>
    <Route path='/savouries' element={<Savouries />}></Route>
    <Route path='/sweets' element={<Sweets />}></Route>
    <Route path='/combo' element={<Combo />}></Route>
    <Route path='/others' element={<Others />}></Route>
    <Route path='/shop' element={<ShopByCategory />}></Route>
    <Route path='/review' element={<Review />}></Route>
    <Route path='/customize' element={<Customize />}></Route>
    <Route path='/gifts' element={<Gift />}></Route>
    <Route path='/refundpolicy' element={<RefundPolicy />}></Route>
    <Route path='/privacypolicy' element={<PrivacyPolicy />}></Route>
    <Route path='/termsandcondition' element={<TermsAndConditions />}></Route>
    <Route path='/Customer' element={<CustomerSupport />}></Route>
   

    </Routes>

    <Footer></Footer>
    </>

  );
}

export default App;
